import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.FUEL].GET_FUEL]: {
		url: '/company/:companyId/fuel/report/',
	},
	[ModulesConfigMap[ModulesMap.FUEL].GET_FUEL_PREVIEW]: {
		url: '/company/:companyId/fuel/report/:machineId/',
	},
}
